// extracted by mini-css-extract-plugin
export default {"logoImg":"Home_logoImg__rcOWa","logoDiv":"Home_logoDiv__NnvTJ","tableDiv":"Home_tableDiv__hwRZs","emptyDiv":"Home_emptyDiv__Gsfe7"};